import { MotivoDevolucionService } from './../../../services/motivo-devolucion.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalAnulacionDocComponent } from './modal-anulacion-doc/modal-anulacion-doc.component';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ModalAgregarDocumentoNotaCreditoComponent } from './modal-agregar-documento-nota-credito/modal-agregar-documento-nota-credito.component';
import { FormValidatorsService } from '../../../shared/services/form-validators.service';
import { DocumentoRecepcionadoService } from '../../../services/documento-recepcionado.service';
import { MessageRendererService } from '../../../services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import * as _ from 'lodash';
import { RutService } from 'src/app/shared/services/rut.service';

@Component({
  selector: 'app-nota-credito',
  templateUrl: './nota-credito.component.html',
  styleUrls: ['./nota-credito.component.scss'],
  providers: [SecurityService],
})
export class NotaCreditoComprasComponent implements OnInit {
  @ViewChild(ModalAnulacionDocComponent, { static: true }) modalAnulacionDoc: ModalAnulacionDocComponent;
  @ViewChild(ModalAgregarDocumentoNotaCreditoComponent, { static: true }) modalAgregarNotaCreditoDocumento: ModalAgregarDocumentoNotaCreditoComponent;

  // Form
  formData: FormGroup;
  public rutEmpresa: number;
  public sucursalCodigo: number;

  // Utils
  private log: any;
  loading: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();
  listaMovimientos: Array<any> = null;
  listaMovimientosAll: Array<any> = null;
  optionsMotivoGeneral: Array<any> = [];

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
    private documenRecepcionadotoService: DocumentoRecepcionadoService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private motivoDevolucionService: MotivoDevolucionService
  ) {
    this.log = this.clog.log('FILTRO DE ANULACION DE DOC');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    this.createForm();
    this.buscar(1);
  }

  OpenAnulacionDoc() {
    this.modalAnulacionDoc.show();
  }

  OpenModalAgregarDoc() {
    this.modalAgregarNotaCreditoDocumento.show();
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formData = this.fb.group({
      fechaDesde: [initDate],
      fechaHasta: [currentDate],
    });
  }

  // NOTE: REALIZAR BUSQUEDA DESPUES DE AGREGAR EL DOCUMENTO

  getItemToSearch($event) {
    this.buscar(1);
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formData);
    if (!this.formData.valid) {
      return;
    }
    this.paginationContext.CurrentPage = pageNumber;
    this.listaMovimientos = null;
    this.listaMovimientosAll = null;

    const { fechaDesde, fechaHasta } = this.formData.value;
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        tipo_dte_codigo: 61, //* NOTA CREDITO!
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;


    this.documenRecepcionadotoService.obtenerDocRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;
      this.listaMovimientosAll = registros;

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = 1;
      this.listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.rut_emisor);
      });
      this.loading = false;
      this.showPage(this.paginationContext.CurrentPage);
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }
}
